import React from 'react';
import FormRow from "v4/components/form/FormRender/components/FormRow/FormRow";
import FormRender from "v4/components/form/FormRender/FormRender";
import PolColumns from "v4/components/utils/PolColumns/PolColumns";

export default function ModuleStatisticsRenderProductForm({formId, form, formErrors, onSubmit}) {
    return (
        <FormRender form={form}
                    formId={formId}
                    formErrors={formErrors}
                    onSubmit={onSubmit}
                    hasToHideRest>
            <FormRow fieldName="statistic_product_configuration[label]"/>
            <FormRow fieldName="statistic_product_configuration[productConfiguration][extraFields]"/>
            <PolColumns cols={2}>
                <FormRow fieldName="statistic_product_configuration[displayListing]"/>
                <FormRow fieldName="statistic_product_configuration[displaySheet]"/>
            </PolColumns>
        </FormRender>
    )
}
